module.exports = __webpack_public_path__ + "static/media/laos-map-on.f388a071.png";